<div class="max-w-6xl mx-auto px-4">
  <div class="mb-6 lg:mb-12">
    <mobo-partner-banner [hasBtn]="false"></mobo-partner-banner>
  </div>
  <div class="mb-6 lg:mb-12">
    <mobo-plans-table></mobo-plans-table>
  </div>
  <div class="mb-6 lg:mb-12">
    <mobo-plans-cards></mobo-plans-cards>
  </div>
</div>
